import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DocumentItem from './DocumentItem';
import DocumentItemHeaders from './DocumentItemHeaders';
import PlaceholderImg from '../../../assets/document-placeholder.svg';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  noItems: {
    width: '24rem',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    paddingTop: '2rem',
  },
  img: {
    width: '5rem',
    margin: '1rem',
    overflow: 'hidden',
    display: 'block',
    marginBottom: '2rem',
  },
}));

const DocumentItemList = ({docs, checkFile, downloadFile, renameFile, deleteFile, setFileCategory}) => {

  const renderNoItems = (classes) => {
    return (
      <div className={classes.noItems}>
        <img
          className={classes.img}
          src={PlaceholderImg}
          alt="placeholder"
        />
        <Typography variant="body2" align="left" gutterBottom>Add documents by clicking the <b>Upload Documents</b> button above or sending an email wto your <b>vault address</b>!</Typography>
      </div>
    );
  };

  const renderItemList = () => {
    return (
      <Fragment>
        <DocumentItemHeaders />
        {docs.map(doc =>
          <DocumentItem
            key={doc.uuid}
            data={doc}
            checkFile={checkFile}
            downloadFile={downloadFile}
            renameFile={renameFile}
            deleteFile={deleteFile}
            setFileCategory={setFileCategory}
          />
        )}
      </Fragment>
    );
  };

  const classes = useStyles();
  return (
    <div className={classes.root}>
      {docs.length === 0 ? (renderNoItems(classes)) : (renderItemList())}
    </div>
  );
};

DocumentItemList.propTypes = {
  docs: PropTypes.array.isRequired,
  checkFile: PropTypes.func.isRequired,
  downloadFile: PropTypes.func.isRequired,
  renameFile: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  setFileCategory: PropTypes.func.isRequired,
};

export default DocumentItemList;
